export default __webpack_public_path__ + "static/media/dis.6af228fa.png";